import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function SectionButton34ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {
        buttonText: stringsTranslate(appWords.contact_us),

    }

    return (
        <section className="section section-button-3-4-for-companies">
            <div className="container-fluid">

                <div className="row align-items-center justify-content-center">
                    <div className="col-12 text-center">
                        <KnaekPrimaryButton
                            title={initStrings.buttonText}
                            onClick={() => handleLinkClick("/contact")}
                        />
                    </div>
                </div>
            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=viGUvE0J8iQ')

        } else {
            window.open('https://www.youtube.com/watch?v=MsbjSpcfLm8')

        }

    }
}
